export const TRANSLATIONS = {
  en: {
    translation: {
      welcome: "Welcome to Facil",
      deposit: "Deposit",
      withdraw: "Withdraw",
      search: "Search",
      searchGames: "Search Games",
      searchYourFavouriteGames: "Search your favourite games",
      mainBalance: "Main Balance",
      cash: "Cash",
      bonus: "Bonus",
      coins: "Coins",
      signIn: "Sign In",
      login: "Login",
      signUp: "Sign Up",
      register: "Register",
      signOut: "Sign Out",
      logOut: "Log Out",

      profile: "Profile",
      casinoBets: "Casino Bets",
      referral: "Referral",
      accountStatement: "Account Statement",

      Logout: "Logout",

      inplay: "Inplay",
      casino: "Casino",
      exchange: "Exchange",
      promotions: "Promotions",

      exposureAmount: "Exposure Amount",
      matchName: "Match Name",
      refMatchID: "Ref Match ID",
      totalBets: "Total Bets",
      odds: "Odds",
      stack: "Stack",
      selectionType: "Selection Type",
      status: "Status",
      createDate: "Create Date",

      allGames: "All Games",
      allCasino: "All Casino",
      sportsGames: "Sports Games",
      slots: "Slots",
      slotMachines: "Slot Machines",
      poker: "Slot Machines",
      sportsbook: "Sportsbook",
      roulette: "Roulette",
      basketball: "Basketball",
      football: "Football",
      tennis: "Tennis",
      aviator: "Aviator",
      horseRacing: "Horse Racing",
      greyhoundRacing: "Greyhound Racing",
      liveCasino: "Live Casino",
      promotion: "Promotion",
      support: "Support",

      trendingGames: "Trending Games",
      netEnt: "Net Ent",
      redTiger: "Red Tiger",
      jili: "Jili",
      jiliGames: "Jili Games",
      hacksawGaming: "Hacksaw Gaming",
      turbo: "Turbo",
      turboGames: "Turbo Games",
      playnGo: "Play'n Go",
      relaxGaming: "Relax Gaming",
      habanero: "Habanero",
      gameArt: "Game Art",
      dragoonSoft: "Dragoon Soft",
      viewAll: "View All",

      frequentlyAskedQuestions: "Frequently Asked Questions",
      faq1: "Does Live Casino have real dealers?",
      faq1Description1:
        "Live Casino is an exciting new way to play your favourite table games. You can enjoy Live Blackjack, Live Baccarat, Live Infinite Blackjack, Live Ultimate Texas Hold'em, Live Baccarat eSqueeze, Live Roulette, and Live Auto Roulette streamed in real-time video, delivering an authentic gambling experience where real dealers shuffle, deal and interact with players, just like in a real casino.",
      faq1Description2:
        "Live Casino game outcomes are determined with real cards whereas other table games on Litoralfacil use a random number generator to determine game outcomes.",

      faq2: "How do I play Live Casino?",
      faq2Description1:
        "Clicking on any of the Live Casino game tiles will launch Live Casino in a new pop up window. You can watch on any game table without sitting down or placing a bet, so feel free to open it and look around!",
      faq2Description2:
        "Alternatively, demo videos of betting on each of the game types are available here.",
      faq2Description3:
        "To place a bet, pick your game type and/or table. If you selected Blackjack, pick an available (green) seat at the table. Select a chip value, then select a betting spot, and your bet is placed. Now the game plays out and your bet is settled based on the game outcome.",

      faq3: "What if I have a Live Casino issue?",
      faq3Description1:
        "If you have an issue, we can help several ways. Live Casino has a chat function that allows you to chat with your dealer or the Live Casino customer support staff to notify them of your issue.",
      faq3Description2:
        "If you have an issue not related to Live Casino, with depositing for example, contact Litoralfacil Customer Support through chat, email or phone, details here",

      faq4: "When is the Live Casino studio open or closed?",
      faq4Description1: "The Live Casino studio is open 24 hours per day.",

      faq5: "What are the system requirements for Live Casino?",
      faq5Description1:
        "Always use the most up-to-date version of your browser to ensure a good Live Casino experience.",

      faq6: "Why can’t I launch Live Casino?",
      faq6Description1:
        "If you can’t launch Live Casino, your Flash player may be blocked. This help article from Adobe, the makers of Flash, provides browser specific troubleshooting info.",

      faq7: "Why does my Live Casino balance not update automatically?",
      faq7Description1:
        "The Live Casino balance updates each time it connects with the Litoralfacil server but these two systems are not always connected. For example, if you deposit money to your Litoralfacil account while the Live Casino client is open, you will not see your balance update in the Live Casino client until an event occurs that requires the client to contact the Litoralfacil server. Here are some examples of events that require the two servers to connect: launching the Live Casino client; opening a table; making a wager; settling a wager.",
    },
  },
  ptbr: {
    translation: {
      welcome: "Bem-vindo à Facil",
      deposit: "Depósito",
      withdraw: "Retirar",
      search: "Procurar",
      searchGames: "Pesquisar jogos",
      searchYourFavouriteGames: "Pesquise seus jogos favoritos",
      mainBalance: "Saldo Principal",
      cash: "Dinheiro",
      bonus: "Bônus",
      coins: "Moedas",
      signIn: "Entrar",
      login: "Conecte-se",
      signUp: "Inscrever-se",
      register: "Cadastre-se",
      signOut: "Sair",
      logOut: "Sair",

      profile: "Perfil",
      casinoBets: "Apostas de Cassino",
      referral: "Referência",
      accountStatement: "Account Statement",

      Logout: "Logout",

      inplay: "Ao vivo",
      casino: "Cassino",
      exchange: "Intercâmbio",
      promotions: "Promoções",

      exposureAmount: "Quantidade de exposição",
      matchName: "Nome da correspondência",
      refMatchID: "ID de correspondência de referência",
      totalBets: "Apostas totais",
      odds: "Chances",
      stack: "Pilha",
      selectionType: "Tipo de seleção",
      status: "Status",
      createDate: "Data de criação",

      allGames: "Todos os jogos",
      allCasino: "Todos Cassino",
      sportsGames: "Jogos esportivos",
      slots: "Slots",
      slotMachines: "caça-níqueis",
      poker: "pôquer",
      sportsbook: "Apostas esportivas",
      roulette: "Roleta",
      basketball: "Basquetebol",
      football: "Futebol",
      tennis: "Tênis",
      aviator: "Aviadora",
      horseRacing: "Corrida de Cavalos",
      greyhoundRacing: "Corrida de galgos",
      liveCasino: "Cassino ao vivo",
      promotion: "Promoção",
      support: "Apoiar",

      trendingGames: "Jogos populares",
      netEnt: "Entidade líquida",
      redTiger: "Tigre Vermelho",
      jili: "Jili",
      jiliGames: "Jili Jogos",
      hacksawGaming: "Jogos de serra",
      turbo: "Turbo",
      turboGames: "Jogos Turbo",
      playnGo: "Jogue e vá",
      relaxGaming: "Relaxe jogando",
      habanero: "Habanero",
      gameArt: "Arte do jogo",
      dragoonSoft: "Dragão Suave",
      viewAll: "Ver tudo",

      frequentlyAskedQuestions: "Perguntas frequentes",
      faq1: "O Live Casino tem crupiês reais?",
      faq1Description1:
        "O Cassino ao Vivo é uma nova e emocionante maneira de jogar seus jogos de mesa favoritos. Você pode desfrutar de Blackjack ao Vivo, Bacará ao Vivo, Blackjack Infinito ao Vivo, Ultimate Texas Hold'em ao Vivo, Bacará eSqueeze ao Vivo, Roleta ao Vivo e Roleta Automática ao Vivo, tudo isso transmitido em tempo real, proporcionando uma experiência de jogo autêntica, onde crupiês reais embaralham, distribuem as cartas e interagem com os jogadores, como em um cassino real.",
      faq1Description2:
        "Os resultados dos jogos de cassino ao vivo são determinados com cartas reais, enquanto outros jogos de mesa no Litoralfacil usam um gerador de números aleatórios para determinar os resultados do jogo.",

      faq2: "Como jogar no Live Casino?",
      faq2Description1:
        "Clicar em qualquer um dos blocos de jogo do Cassino ao Vivo abrirá o Cassino ao Vivo em uma nova janela pop-up. Você pode assistir em qualquer mesa de jogo sem precisar se sentar ou fazer uma aposta, então sinta-se à vontade para abri-la e dar uma olhada!",
      faq2Description2:
        "Como alternativa, vídeos de demonstração de apostas em cada um dos tipos de jogo estão disponíveis aqui.",
      faq2Description3:
        "Para fazer uma aposta, escolha o tipo de jogo e/ou a mesa. Se você selecionou Blackjack, escolha um lugar disponível (verde) na mesa. Selecione o valor da ficha, depois selecione um local de aposta e sua aposta será feita. Agora o jogo se desenrola e sua aposta é definida com base no resultado.",

      faq3: "E se eu tiver um problema com o Live Casino?",
      faq3Description1:
        "Se você tiver algum problema, podemos ajudar de várias maneiras. O Cassino ao Vivo possui uma função de bate-papo que permite que você converse com o seu dealer ou com a equipe de suporte ao cliente do Cassino ao Vivo para notificá-los sobre o seu problema.",
      faq3Description2:
        "Se você tiver um problema não relacionado ao Live Casino, com depósito por exemplo, entre em contato com o Suporte ao Cliente Litoralfacil por chat, e-mail ou telefone, detalhes aqui",

      faq4: "Quando o estúdio do Live Casino abre ou fecha?",
      faq4Description1:
        "O estúdio do Live Casino fica aberto 24 horas por dia.",

      faq5: "Quais são os requisitos de sistema para o Live Casino?",
      faq5Description1:
        "Use sempre a versão mais atualizada do seu navegador para garantir uma boa experiência no Live Casino.",

      faq6: "Por que não consigo iniciar o Live Casino?",
      faq6Description1:
        "Se você não conseguir iniciar o Live Casino, seu Flash Player pode estar bloqueado. Este artigo de ajuda da Adobe, criadora do Flash, fornece informações específicas para solução de problemas em navegadores.",

      faq7: "Por que meu saldo do Live Casino não é atualizado automaticamente?",
      faq7Description1:
        "O saldo do Cassino ao Vivo é atualizado sempre que se conecta ao servidor Litoralfacil, mas esses dois sistemas nem sempre estão conectados. Por exemplo, se você depositar dinheiro na sua conta Litoralfacil enquanto o cliente do Cassino ao Vivo estiver aberto, você não verá a atualização do seu saldo no cliente do Cassino ao Vivo até que ocorra um evento que exija que o cliente entre em contato com o servidor Litoralfacil. Aqui estão alguns exemplos de eventos que exigem a conexão dos dois servidores: iniciar o cliente do Cassino ao Vivo; abrir uma mesa; fazer uma aposta; liquidar uma aposta.",
    },
  },
};
